import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { authAPI } from './services/api';
import './EmailVerified.css';

function ResetPassword() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) { setError(t('resetPassword.passwordTooShort')); return; }
    if (newPassword !== confirmPassword) { setError(t('resetPassword.passwordsMismatch')); return; }
    setLoading(true);
    setError('');
    try {
      await authAPI.resetPassword(token, newPassword);
      setSuccess(true);
    } catch (err) {
      const msg = err.response?.data;
      setError(typeof msg === 'string' && msg ? msg : t('resetPassword.failed'));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="email-verified-container">
        <div className="email-verified-card">
          <div className="email-verified-icon" style={{ backgroundColor: '#e53935' }}>✕</div>
          <h1>{t('resetPassword.title')}</h1>
          <p>{t('resetPassword.invalid')}</p>
          <button className="email-verified-btn" onClick={() => navigate('/')}>{t('resetPassword.goToLogin')}</button>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="email-verified-container">
        <div className="email-verified-card">
          <div className="email-verified-icon">✓</div>
          <h1>{t('resetPassword.success')}</h1>
          <p>{t('resetPassword.successSub')}</p>
          <button className="email-verified-btn" onClick={() => navigate('/')}>{t('resetPassword.goToLogin')}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="email-verified-container">
      <div className="email-verified-card">
        <h1>{t('resetPassword.title')}</h1>
        <form onSubmit={handleSubmit} style={{ textAlign: 'left', marginTop: 24 }}>
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, color: '#2c3e50' }}>
            {t('resetPassword.newPassword')}
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            placeholder="••••••••"
            autoFocus
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: '1rem', marginBottom: 16, boxSizing: 'border-box' }}
          />
          <label style={{ display: 'block', marginBottom: 6, fontWeight: 500, color: '#2c3e50' }}>
            {t('resetPassword.confirmPassword')}
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            placeholder="••••••••"
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: '1rem', marginBottom: 16, boxSizing: 'border-box' }}
          />
          {error && <p style={{ color: '#e53935', fontSize: '0.9rem', marginBottom: 16 }}>{error}</p>}
          <button
            className="email-verified-btn"
            type="submit"
            disabled={loading || !newPassword || !confirmPassword}
            style={{ width: '100%' }}
          >
            {loading ? t('resetPassword.resettingBtn') : t('resetPassword.resetBtn')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;